module.exports = __webpack_public_path__ + "static/img/SGZeus.ee3f288.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SGZeus.jpg
// module id = b7lI
// module chunks = 0